import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import RecentAlert from './RecentAlert';

const Container = styled.div`
  background-color: ${props => props.theme.enigmaWhite};
  border-radius: 0px 0px 5px 5px;
  box-shadow: ${props => props.theme.defaultShadow};
  display: inline-block;
  width: 100%;
  z-index: 99;
`;

const Row = styled.div`
  padding: 15px;
  color: ${props => props.theme.fontTertiary};
  border-radius: 0px 0px 5px 5px;
  background-color: ${props => props.theme.enigmaWhite};
`;
const RowHover = styled(Row)`
  cursor: pointer;
  &:hover {
    background-color: ${props => props.theme.primaryHover};
  }
`;

function RecentAlertList({ list, onClickAlert }) {
  if (list.length === 0) return <span></span>;

  return (
    <Container>
      <Row>Recent Alerts</Row>
      {list.map(item => {
        const onClick = e => {
          onClickAlert(item.id);
        };
        return (
          <RowHover key={item.id} onMouseDown={onClick}>
            <RecentAlert {...item} />
          </RowHover>
        );
      })}
    </Container>
  );
}

RecentAlertList.propTypes = {
  onClickAlert: PropTypes.func.isRequired,
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.number.isRequired,
    })
  ),
};

RecentAlertList.displayName = 'RecentAlertList';

export default RecentAlertList;
